var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodejsColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1928",
    "data-name": "Rectangle 1928",
    width: 52,
    height: 52,
    transform: "translate(396 763)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19812",
    "data-name": "Path 19812",
    d: "M28.1,26.637,23.145,29.5a.6.6,0,0,0-.3.518v5.721a.6.6,0,0,0,.3.518L28.1,39.113a.6.6,0,0,0,.6,0l4.952-2.861a.6.6,0,0,0,.3-.518V30.013a.6.6,0,0,0-.3-.518L28.7,26.637a.6.6,0,0,0-.6,0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.847,
    y1: -1.034,
    x2: -0.838,
    y2: -1.034,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3e863d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#55934f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5aad45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19814",
    "data-name": "Path 19814",
    d: "M22.969,36.1a.6.6,0,0,0,.176.155l4.248,2.454.708.407a.6.6,0,0,0,.345.078.612.612,0,0,0,.118-.022l5.223-9.564a.592.592,0,0,0-.139-.11L30.4,27.623l-1.714-.986a.625.625,0,0,0-.155-.062Zm0,0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.742,
    y1: -0.932,
    x2: -0.737,
    y2: -0.932,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#3e863d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#619857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76ac64"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19816",
    "data-name": "Path 19816",
    d: "M28.337,26.56a.6.6,0,0,0-.239.077l-4.938,2.85,5.325,9.7a.594.594,0,0,0,.213-.073l4.952-2.861a.6.6,0,0,0,.289-.409L28.51,26.57a.622.622,0,0,0-.121-.012l-.049,0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -2.148,
    y1: -2.103,
    x2: -2.138,
    y2: -2.103,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6bbf47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#79b461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#75ac64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#659e5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3e863d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_38",
    "data-name": "Mask Group 38",
    transform: "translate(-396 -763)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Node.js_logo",
    transform: "translate(396 773.076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19807",
    "data-name": "Path 19807",
    d: "M25.7,31.847a.988.988,0,0,1-.493-.132l-1.568-.928c-.234-.131-.12-.177-.043-.2a3.165,3.165,0,0,0,.709-.323.119.119,0,0,1,.117.008l1.2.715a.159.159,0,0,0,.146,0l4.7-2.711a.148.148,0,0,0,.072-.127V22.727a.151.151,0,0,0-.073-.129l-4.694-2.708a.144.144,0,0,0-.145,0L20.937,22.6a.15.15,0,0,0-.074.128v5.419a.145.145,0,0,0,.073.126l1.286.743c.7.349,1.125-.062,1.125-.476V23.189a.134.134,0,0,1,.136-.135h.595a.134.134,0,0,1,.135.135V28.54a1.3,1.3,0,0,1-1.391,1.466,2.013,2.013,0,0,1-1.083-.294L20.508,29a.993.993,0,0,1-.493-.857V22.726a.987.987,0,0,1,.493-.856l4.7-2.712a1.03,1.03,0,0,1,.987,0l4.695,2.713a.991.991,0,0,1,.493.856v5.419a.994.994,0,0,1-.493.856L26.2,31.713a.987.987,0,0,1-.495.132",
    fill: "#689f63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19808",
    "data-name": "Path 19808",
    d: "M27.152,28.113c-2.055,0-2.486-.943-2.486-1.734a.135.135,0,0,1,.136-.135h.607a.136.136,0,0,1,.134.115c.092.618.364.93,1.607.93.99,0,1.411-.224,1.411-.748,0-.3-.12-.527-1.657-.677-1.286-.127-2.081-.41-2.081-1.439,0-.947.8-1.512,2.138-1.512,1.5,0,2.249.522,2.343,1.643a.137.137,0,0,1-.036.1.14.14,0,0,1-.1.043h-.61a.135.135,0,0,1-.132-.106c-.147-.65-.5-.858-1.467-.858-1.08,0-1.206.376-1.206.658,0,.342.148.442,1.606.635s2.129.462,2.129,1.476-.853,1.609-2.342,1.609m5.72-5.747h.158a.137.137,0,0,0,.154-.143c0-.139-.1-.139-.148-.139h-.162Zm-.192-.444h.349c.12,0,.355,0,.355.268a.233.233,0,0,1-.192.249c.14.009.149.1.168.23a.991.991,0,0,0,.053.268h-.215c-.006-.047-.039-.306-.039-.32-.014-.058-.034-.086-.106-.086H32.87v.407h-.2Zm-.42.505a.759.759,0,1,0,.756-.757.76.76,0,0,0-.756.757m1.664,0a.905.905,0,1,1-.905-.905.908.908,0,0,1,.905.905",
    fill: "#689f63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19809",
    "data-name": "Path 19809",
    d: "M11.16,10.644a.6.6,0,0,0-.3-.523L5.88,7.257a.581.581,0,0,0-.274-.079H5.555a.592.592,0,0,0-.275.079L.3,10.122a.606.606,0,0,0-.3.523l.011,7.716a.3.3,0,0,0,.149.26.284.284,0,0,0,.3,0l2.96-1.7a.607.607,0,0,0,.3-.522V12.8a.6.6,0,0,1,.3-.521l1.26-.726a.6.6,0,0,1,.3-.081.587.587,0,0,1,.3.081l1.26.726a.6.6,0,0,1,.3.521v3.6a.609.609,0,0,0,.3.522L10.7,18.619a.294.294,0,0,0,.3,0,.3.3,0,0,0,.149-.26Zm23.494,4.017a.149.149,0,0,1-.075.13l-1.71.986a.151.151,0,0,1-.15,0l-1.71-.986a.149.149,0,0,1-.075-.13V12.687a.151.151,0,0,1,.074-.13l1.709-.987a.152.152,0,0,1,.152,0l1.71.987a.15.15,0,0,1,.075.13ZM35.116.038A.3.3,0,0,0,34.668.3V7.942a.21.21,0,0,1-.316.182l-1.247-.718a.6.6,0,0,0-.6,0L27.524,10.28a.6.6,0,0,0-.3.52v5.75a.6.6,0,0,0,.3.521L32.5,19.947a.6.6,0,0,0,.6,0l4.981-2.878a.6.6,0,0,0,.3-.521V2.217a.6.6,0,0,0-.309-.525ZM51.7,12.635a.6.6,0,0,0,.3-.52V10.722a.6.6,0,0,0-.3-.52L46.752,7.329a.6.6,0,0,0-.6,0L41.169,10.2a.6.6,0,0,0-.3.521v5.748a.6.6,0,0,0,.3.523l4.948,2.82a.6.6,0,0,0,.59,0L49.7,18.155a.3.3,0,0,0,0-.523l-5.01-2.875a.3.3,0,0,1-.152-.26v-1.8a.3.3,0,0,1,.15-.26l1.559-.9a.3.3,0,0,1,.3,0l1.56.9a.3.3,0,0,1,.15.26V14.11a.3.3,0,0,0,.451.26Zm0,0",
    fill: "#333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19810",
    "data-name": "Path 19810",
    d: "M46.377,12.366a.114.114,0,0,1,.115,0l.956.551a.115.115,0,0,1,.058.1v1.1a.115.115,0,0,1-.058.1l-.956.551a.114.114,0,0,1-.115,0l-.955-.551a.115.115,0,0,1-.059-.1v-1.1a.114.114,0,0,1,.058-.1Zm0,0",
    fill: "#689f63",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15853",
    "data-name": "Group 15853",
    transform: "translate(-9.205 -19.28)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19811",
    "data-name": "Path 19811",
    d: "M38.951,29.01,25,22.17l-7.155,14.6L31.8,43.607Zm0,0",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15854",
    "data-name": "Group 15854",
    transform: "translate(-9.205 -19.28)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19813",
    "data-name": "Path 19813",
    d: "M16.935,31.033,26.789,44.37,39.82,34.742,29.966,21.406Zm0,0",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15855",
    "data-name": "Group 15855",
    transform: "translate(-9.205 -19.28)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19815",
    "data-name": "Path 19815",
    d: "M23.159,26.558V39.186H33.937V26.558Zm0,0",
    fill: "url(#linear-gradient-3)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejsColored);
export default __webpack_public_path__ + "static/media/nodejs-colored.8897e2193a4037504a4b1fcc5d3fc3f0.svg";
export { ForwardRef as ReactComponent };